import { render, staticRenderFns } from "./prestashop-plugin-page.vue?vue&type=template&id=d9f9fa2a&scoped=true"
import script from "./prestashop-plugin-page.vue?vue&type=script&lang=js"
export * from "./prestashop-plugin-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f9fa2a",
  null
  
)

export default component.exports